import httpService from './httpService';
import { Formation } from '../utils/types';

export const createFormation = async (basin: Formation) => {
	const { data } = await httpService.post(`/formations`, basin);
	return data;
};

export const search = async (params?: any) => {
	const { data } = await httpService.get(`/formations/search`, { params });
	return data;
};

export const getFormation = async (id: string) => {
	const { data } = await httpService.get(`/formations/${id}`);
	return data;
};

export const deleteFormation = async (id: string | number) => {
	const { data } = await httpService.delete(`/formations/${id}`);
	return data;
};

export const updateFormation = async (basin: any) => httpService.put(`/formations/${basin.id}`, basin);
